var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"b2b-loading"},[_c('div',{staticClass:"spinner"},_vm._l((8),function(n){return _c('span',{key:n})}),0),_c('img',{staticClass:"loading-image",attrs:{"src":require("@/assets/tbeasy-loading.svg"),"alt":"TBEasy loading"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }